// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

// this file manages the opening and closing of center column items
import { ref } from 'vue'
import { store } from '@/store'

//const store = useStore()

const newGenomics = ref(false)
const newReports = ref(false)
const newCenter = ref(false)
const newPathology = ref(false)

// clears current view and switches to new view
export const clearCenterColumn = (newWindow) => {
  newCenter.value = true
  // add new center column items below
  // genomics
  newGenomics.value = newWindow === 'genomics'

  // Reports
  newReports.value = newWindow === 'reports'

  // Pathology
  newPathology.value = newWindow === 'pathology'

  const centerColumnState = {
    container: newCenter.value,
    genomics: newGenomics.value,
    reports: newReports.value,
    pathology: newPathology.value,
  }
  store.dispatch('setCenterColumnState', { centerColumnState, publish: true })
}

// closes all
export const closeCenterColumn = () => {
  // close center column
  newCenter.value = false
  // close genomics
  newGenomics.value = false
  // close Reports
  newReports.value = false
  // close Pathology
  newPathology.value = false

  const centerColumnState = {
    container: newCenter.value,
    genomics: newGenomics.value,
    reports: newReports.value,
    pathology: newPathology.value,
  }
  store.dispatch('setCenterColumnState', { centerColumnState, publish: true })
}

